import React from 'react';

import AdminIcon from './admin-lock.svg';
import PublicIcon from '../../../images/icons/public-eye.svg';

import './strategy-visibility.scss';

const options = [
  {
    name: 'public',
    label: 'Public',
    subText:
      'If set to public, this campaign (draft or completed) will be visible to Publishers' +
      ' on the New Rates Page.',
  },
  {
    name: 'admin',
    label: 'Admin Only',
    subText:
      'This campaign (draft or completed) will only be visible to you and your internal team.',
  },
];

function StrategyVisibility({
  visibilityProp,
  strategyId,
  updateVisibility,
  label = 'Campaign Visibility',
  checked,
}) {
  const radioButtons = options.map((option, idx) => {
    return (
      <div className={`${option.name}-container`} key={idx}>
        <div className="radio-container">
          <input
            type="radio"
            value={option.name}
            name={`visibility-radio-${strategyId}`}
            id={`${option.name}-radio-${strategyId}`}
            onClick={() => updateVisibility(option.name)}
            checked={checked ? checked === option.name : undefined}
            defaultChecked={visibilityProp === option.name}
          />
          <label className="radio-button-label" htmlFor={`${option.name}-radio-${strategyId}`}>
            {option.label}
          </label>
          <img src={option.name === 'public' ? PublicIcon : AdminIcon} alt={option.name} />
        </div>
        <p className="visibility-subtext">{option.subText}</p>
      </div>
    );
  });

  return (
    <div className="visibility-container">
      {label && <div className="visibility-label">{label}</div>}
      {radioButtons}
    </div>
  );
}

export default StrategyVisibility;
